import baseReport from './baseReport';
import moment from 'moment'

const comprovante = async (dados) => {

    const date = moment().format('DD/MM/YYYY')
    const time = moment().format('HH:mm:ss')

    const headerFooter = await baseReport({ date, time, title: 'Comprovante Distribuição de Aulas online', subTitle: dados.dstpcargo });

    const aulas = dados.aulasEfetivacao.map(aula => [
        {text: aula.nmescola},
        {text: aula.dsinstruc +'/'+ aula.dsserie},
        {text: aula.turno},
        {text: aula.dsdiscipl},
        {text: aula.qtdaulasselecionadas, alignment: 'center'},           
               
    ])

    const filtrosFormated = [
        {
            text: 'Ano letivo: ' + dados.dadosDaInscricao.aaletivo
        }

    ]

    const dataFormated = [
        {
            text: 'As aulas de ' + dados.dadosFuncionario.nmfuncion.trim() + ', matrícula ' + dados.dadosFuncionario.cdpessoal + ' ' +
            dados.dadosFuncionario.cdmatric+'-'+dados.dadosFuncionario.dgmatric+', foram efetivadas conforme mostra abaixo:',
            margin: [0, 100],
            alignment: 'justify'
        },
        {
            table: {
                body: [
                    [{text: 'Escola' }, 
                        {text: 'Etapa Escolar' }, 
                        {text: 'Turno'},
                        {text: 'Disciplina/Função'}, 
                        {text: 'Qtd módulos selecionados'}],
                    ...aulas,

                ],
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex % 2 === 0) ? '#CCCCCC' : null;
                    }
                }
            }
        },
        {
            text: [
                    { text: 'Orientação: A SME tem a responsabilidade para as ', bold: false},
                    { text: 'efetivações online ', bold: true},
                    { text: 'de enviar o seu encaminhamento (CI) para as unidades escolares ', bold: false,}
                ],
            margin: [0, 200],
            alignment: 'justify'
        },
    ]



    return {
        ...headerFooter,
        content: [
           // ...dados,
        ...filtrosFormated,
         ...dataFormated,
         // ...exibirTotalGeral,
         // ...montarAssinatura(professores, filtros, tipoDeEnsino),
        ],
        styles: {
          tableHeader: {
            bold: true,
            fontSize: 10,
            color: 'black',
            fillColor: '#eeeeee',
            alignment: 'center',
          },
        },
      };

}


export {comprovante}